import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { Taxonomy } from '@/features/lexicals/passages/api/types'
import { taxonomiesApi } from '../api/taxonomiesApi'

type LoadStatus = 'idle' | 'loading' | 'ready' | 'failed'

interface TaxonomyCatalogState {
  items: Taxonomy[]
  status: LoadStatus
  error: string | null
}

const initialState: TaxonomyCatalogState = {
  items: [],
  status: 'idle',
  error: null,
}

export const fetchTaxonomyCatalog = createAsyncThunk(
  'taxonomyCatalog/fetch',
  async () => taxonomiesApi.list(),
  {
    condition: (_, { getState }) => {
      const state = getState() as { taxonomyCatalog: TaxonomyCatalogState }
      return state.taxonomyCatalog.status === 'idle' || state.taxonomyCatalog.status === 'failed'
    },
  },
)

const taxonomyCatalogSlice = createSlice({
  name: 'taxonomyCatalog',
  initialState,
  reducers: {
    invalidateTaxonomyCatalog: (state) => {
      state.status = 'idle'
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaxonomyCatalog.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchTaxonomyCatalog.fulfilled, (state, action) => {
        state.items = action.payload
        state.status = 'ready'
      })
      .addCase(fetchTaxonomyCatalog.rejected, (state, action) => {
        if (action.meta.condition) return
        state.status = 'failed'
        state.error = action.error.message || 'Không thể tải taxonomy.'
      })
  },
})

export const { invalidateTaxonomyCatalog } = taxonomyCatalogSlice.actions
export default taxonomyCatalogSlice.reducer
